/**
 * English translations (flat format to avoid nesting issues)
 */
export default {
  // Basic words
  "language": "Language",
  "title": "Delivery Appointment",
  "confirm": "Confirm Appointment",

  // Basic information
  "baseInfo.title": "Basic Info",
  "baseInfo.name": "Name",
  "baseInfo.phone": "Contact Info",
  "baseInfo.address": "Installation Address",
  "baseInfo.expectDate": "Expected Visit Date",
  "baseInfo.service": "Service Content",
  "baseInfo.extra": "Extra Requirements",
  "baseInfo.remark": "Remark",
  "baseInfo.remarkPlaceholder": "Please enter",
  "basicInfo.goods": "Items",
  "baseInfo.fillName": "Please enter your name",
  "baseInfo.fillContact": "Please enter your contact info",
  "baseInfo.fillAddress": "Please enter installation address",
  "baseInfo.selectService": "Please select service",
  "baseInfo.selectDate": "Please select expected visit date",

  // Appointment related
  "appointment.title": "Appointment Time",
  "appointment.warning": "If delivery fails due to customer reasons, $40 will be charged",
  "appointment.days.today": "Today",
  "appointment.days.tomorrow": "Tomorrow",
  "appointment.days.monday": "Monday",
  "appointment.days.tuesday": "Tuesday",
  "appointment.days.wednesday": "Wednesday",
  "appointment.days.thursday": "Thursday",
  "appointment.days.friday": "Friday",
  "appointment.days.saturday": "Saturday",
  "appointment.days.sunday": "Sunday",
  "appointment.timeSlot.title": "Select Time Slot",
  "appointment.timeSlot.slot1": "08:00-11:00",
  "appointment.timeSlot.slot2": "10:00-13:00",
  "appointment.timeSlot.slot3": "12:00-15:00",
  "appointment.timeSlot.slot4": "14:00-17:00",
  "appointment.timeSlot.slot5": "17:00-20:00",

  // Contact information
  "contact.title": "Secondary Contact",
  "contact.mobile": "Mobile",
  "contact.email": "Email",
  "contact.placeholder": "Please enter",

  // Door information
  "doorInfo.title": "Gate Information",
  "doorInfo.hasDoor": "Has Gate",
  "doorInfo.noDoor": "No Gate",
  "doorInfo.passwordTitle": "Gate Password",
  "doorInfo.passwordPlaceholder": "Enter gate code",
  "doorInfo.passwordRequired": "Gate code required",

  // Delivery method
  "delivery.title": "Delivery Placement",
  "delivery.placeholder": "Please select",
  "delivery.photoOptional": "Optional",
  "delivery.photoPlaceholder": "Upload placement photo",
  "delivery.photoUploadSuccess": "Photo uploaded",
  "delivery.photoDeleted": "Photo deleted",
  "delivery.viewPhoto": "View Photo",
  "delivery.noPhotoAvailable": "No photo available",
  "delivery.locations.frontPorch": "Front Porch",
  "delivery.locations.garage": "Garage",
  "delivery.locations.backDoor": "Back Door",
  "delivery.locations.sideEntrance": "Side Entrance",
  "delivery.locations.buildingLobby": "Building Lobby",

  // Installation
  "installation.title": "Installation Required",
  "installation.yes": "Yes",
  "installation.no": "No",

  // Stairs
  "stairs.title": "Delivery Upstairs Required",
  "stairs.yes": "Yes",
  "stairs.no": "No",

  // Success popup
  "successPopup.title": "Appointment Successful",
  "successPopup.appointmentTime": "Delivery Time",
  "successPopup.cancellationNote": "If delivery fails due to customer reasons, $40 will be charged",
  "successPopup.viewDetails": "View Appointment Details",

  // Error messages
  "errors.noTrackingNumber": "No valid tracking number found",
  "errors.apiError": "Failed to get appointment information",
  "errors.networkError": "Network request failed, please try again later",
  "errors.selectTimeSlot": "Please select a time slot",

  // Order details
  "orderDetail.title": "Appointment Details",
  "orderDetail.editAppointment": "Edit Appointment",
  "orderDetail.loading": "Loading...",
  "orderDetail.customerService": "Call Customer Service",

  // Review related
  "review.title": "Customer Review",
  "review.areYouSatisfied": "Are you satisfied with this installation service?",
  "review.satisfied": "Satisfied",
  "review.disatisfied": "Not Satisfied",
  "review.pleaseRateService": "Please rate this service",
  "review.overallScore": "Overall Score",
  "review.workEfficiency": "Work Efficiency",
  "review.communicationExperience": "Communication Experience",
  "review.yourImpression": "Your impression of the technician",
  "review.confirmSignature": "Confirm Signature",
  "review.reSign": "Re-sign",
  "review.clickSign": "Click to sign",
  "review.file": "Signature File",
  "review.comment": "Comment",
  "review.enterComment": "Please enter your comment",
  "review.submit": "Submit",
  "review.noOrderNo": "Order number missing",
  "review.selectSatisfaction": "Please select satisfaction",
  "review.selectTags": "Please select impression tags",
  "review.selectInteractScore": "Please rate communication",
  "review.selectWorkScore": "Please rate work efficiency",
  "review.selectServiceScore": "Please rate overall score",
  "review.signRequired": "Please sign first",
  "review.thanks": "Thank you for your review!",
  "review.scoreUnit": "pt",

  // Index page related
  "index.title": "Installation Appointment",
  "index.flowCardTitle": "Installation Process",
  "index.prepareCardTitle": "Preparation Before Installation",
  "index.step1Title": "Submit Appointment Information",
  "index.step1Desc": "Please fill in the appointment information carefully, take and upload real installation environment photos as needed to help technicians understand the situation in advance.",
  "index.step2Title": "Electrician Accepts Order / Pre-visit Communication",
  "index.step2Desc": "After the electrician accepts the order, they will communicate service details and confirm the service time with you.",
  "index.step3Title": "On-site Work",
  "index.step3Desc": "Please prepare the installation area before the technician arrives, and inform them in time if there are special circumstances.",
  "index.step4Title": "Completion Confirmation / Service Evaluation",
  "index.step4Desc": "Please supervise the technician's work at any time, confirm and sign after completion, and you are invited to give a real evaluation of the technician's service.",
  "index.prepare1": "Ensure the installation area is clean and tidy, and remove obstacles that may affect the installation.",
  "index.prepare2": "If you need to remove old equipment, please back up and transfer data in advance.",
  "index.customerService": "Customer Service",
  "index.callHotline": "Call Hotline",
  "index.nextStep": "Next Step",
  "index.noOrderNoTip": "Please contact customer service to get the order link",

  // Step progress related
  "stepProgress.title": "Application Steps",
  "stepProgress.installDesc": "Installation Instructions",
  "stepProgress.basicInfo": "Basic Information",
  "stepProgress.installPosition": "Installation Position",
  "stepProgress.circuitInfo": "Circuit Information",
  "stepProgress.finish": "Appointment Complete",

  // Common words
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.prev": "Previous",
  "common.next": "Next",

  // Extra requirements
  "extra.title": "Extra Requirements",
  "extra.sub": "Multiple selection allowed",
  "extra.confirm": "Confirm",
  "extra.需要布线": "Wiring required",
  "extra.需要拆除旧设备": "Remove old equipment",
  "extra.需要打孔": "Drilling required",
  "extra.需要接油机": "Oil machine connection",
  "extra.需要配件适配": "Accessory adaptation",

  // New installation position related
  "install.title": "Installation Position",
  "install.position": "Installation Position",
  "install.wallType": "Wall Type",
  "install.select": "Please select",
  "install.photo": "Installation Position Photo",
  "install.photoTip": "Please take photos of the installation position from multiple angles for technician evaluation",
  "install.concrete": "Concrete",
  "install.wood": "Wood",
  "install.wall": "Wall",
  "install.ground": "Ground",
  "install.onlyJpgPng": "Only JPG/PNG format supported",
  "install.maxSize": "Image size cannot exceed 5MB",
  "install.fileTypeError": "File type error",
  "install.uploadFail": "Upload failed",
  "install.selectWallType": "Please select wall type",
  "install.selectPosition": "Please select installation position",
  "install.uploadPhoto": "Please upload installation position photo",

  // Circuit information
  "circuit.title": "Circuit Information",
  "circuit.mainBox": "Main Power Box",
  "circuit.mainBoxTip": "Please photograph the innermost switch for power supply assessment.",
  "circuit.meter": "Electric Meter",
  "circuit.wire": "Wire Reserve & Surroundings",
  "circuit.distance": "Distance from Distribution Box to Smart Panel",
  "circuit.distanceTip": "Please record or upload a video to help technicians assess installation difficulty and required materials.",
  "circuit.submit": "Submit Information",
  "circuit.onlyJpgPng": "Only JPG/PNG format supported",
  "circuit.maxSize": "Image size cannot exceed 15MB",
  "circuit.onlyVideo": "Only video files supported",
  "circuit.maxVideoSize": "Video size cannot exceed 150MB",
  "circuit.fileTypeError": "File type error",
  "circuit.uploadFail": "Upload failed",
  "circuit.uploadMainBox": "Please upload main power box photo",
  "circuit.uploadMeter": "Please upload electric meter photo",
  "circuit.uploadWire": "Please upload wire reserve & surroundings photo",
  "circuit.uploadDistance": "Please upload distance video",
  "circuit.submitSuccess": "Submitted successfully",
  "circuit.networkError": "Network error, submission failed",

  // Order success related
  "orderSuccess.title": "Appointment Complete",
  "orderSuccess.success": "Appointment Successful",
  "orderSuccess.orderId": "Order No.:",
  "orderSuccess.address": "Installation Address",
  "orderSuccess.name": "Name",
  "orderSuccess.phone": "Phone",
  "orderSuccess.expectTime": "Expected Visit Time",
  "orderSuccess.customerService": "Customer Service",
  "orderSuccess.callHotline": "Call Hotline",

  // DatePicker related
  "datePicker.title": "Expected Visit Time",
  "datePicker.dateTitle": "Expected Date",
  "datePicker.dateTip": "Multiple dates can be selected for technician scheduling",
  "datePicker.selected": "Selected:",
  "datePicker.to": "to",
  "datePicker.period": "period",
  "datePicker.timeLabel": "Select Time Slot",
  "datePicker.time1": "08:00-12:00",
  "datePicker.time2": "13:00-17:00",
  "datePicker.time3": "18:00-21:00",
  "datePicker.month": "-",
  "datePicker.day": ""
}; 